export const DIALOG_TYPE = Object.freeze({
  ALERT: 'alert',
  CONFIRM: 'confirm',
  PROMPT: 'prompt',
});

export const SUPPORT_LANGUAGE = Object.freeze(['ko', 'en', 'ja']);

export const PERSISTEDSTATE_KEY = Object.freeze({
  AUTH: 'owlens-auth',
  USER: 'owlens-user',
});

/**
 * BOM 객체 window에 Vue 인스턴스를 할당하고
 * JavaScript 파일에서 그것을 참조하여 다국어 메시지를 사용하기 위한 용도로만 쓰임.
 * Comment.by.KWShin.2025.04.08.
 */
export const VUE_INSTANCE_NAME = Object.freeze('_vue_instance_');

export const CHANGE_STATUS = Object.freeze({
  NORMAL: 'NORMAL',
  INSERTED: 'INSERTED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
  NOTEXIST: 'NOTEXIST',
});

export const DEFAULT_COLORS = Object.freeze(['#26A69A', '#00BCD4', '#039BE5', '#7986CB', '#7CB342', '#FBC02D', '#FF6F00', '#E53935', '#F06292', '#9E9E9E']);

// BEGIN::Added.by.KWShin.
// Workprocess의 type별 status별 색상표
// 모든 type을 그래프에 다 구분해서 보여주었을 때의 각 타입의 상태별 색상.
export const WORKPRCS_COLORS = Object.freeze([
  { type: '', status: [2, 4, 8, 16, 32, 64, 128] },
  { type: 'DIA', colors: ['#03A9F4', '#29B6F6', '#4FC3F7', '#81D4FA', '#B3E5FC', '#E1F5FE', '#039BE5'] },
  { type: 'UPD', colors: ['#D35400', '#DC7633', '#E59866', '#EDBB99', '#F6DDCC', '#FBEEE6', '#BA4A00'] },
  { type: 'ENQ', colors: ['#D4AC0D', '#F1C40F', '#F4D03F', '#F7DC6F', '#F9E79F', '#FCF3CF', '#B7950B'] },
  { type: 'BGD', colors: ['#884EA0', '#9B59B6', '#AF7AC5', '#C39BD3', '#D7BDE2', '#EBDEF0', '#76448A'] },
  { type: 'SPO', colors: ['#95A5A6', '#AAB7B8', '#BFC9CA', '#D5DBDB', '#EAEDED', '#F4F6F6', '#839192'] },
  { type: 'UP2', colors: ['#2ECC71', '#58D68D', '#58D68D', '#ABEBC6', '#D5F5E3', '#EAFAF1', '#28B463'] },
]);
/**
 * Type별/Status별로 모두 색상을 구분하면 차트가 너무 복잡해져서
 * UPD, ENQ, SPO, UP2를 모두 SPO의 색으로 보여줄 때 사용하는 색상표.
 * 2024.01.27.KWShin.
 */
export const WORKPRCS_COLORS_ABBR = Object.freeze([
  // eslint-disable-next-line prettier/prettier
  { type: '', status: [[4, 8, 16], [2, 32, 64, 128]] },
  { type: '1', colors: ['#2979FF', '#00B0FF'] }, // DIA
  { type: '4', colors: ['#4A148C', '#D500F9'] }, // BGD
  { type: '2,3,5,6', colors: ['#212121', '#BDBDBD'] }, // Others...
]);

// BEGIN::Added.by.KWShin.2026.10.28.
// Whole 화면 User / Work Process 영역 파이 차트의 기본 색 (Preference > General > 차트 설정의 기본값과 같이 쓴다).
// 사용자가 차트 설정에서 색을 저장하면 저장한 색이 우선한다.
// Work Process Type 파이의 기본 색은 따로 두지 않고 WORKPRCS_COLORS 의 유형별 첫 색(status 2)을 쓴다
// (WORKPRCS_COLORS 의 유형 순서 DIA, UPD, ENQ, BGD, SPO, UP2 = wp type 1 ~ 6).
// User Type: logon type 2(System), 4(GUI), 32(RFC), 202(Plugin) 순서
export const USER_TYPE_COLORS = Object.freeze(['#9E9E9E', '#7986CB', '#039BE5', '#26A69A']);
// Work Process Status: status 2(Waiting), 4(Running), 8(OnHold), 16(Stopped), 32(Shutdown), 64(Reserved), 128(Started) 순서
export const WORKPRCS_STATUS_COLORS = Object.freeze(['#4FC3F7', '#1565C0', '#61A0A8', '#D48265', '#91C7AE', '#749F83', '#CA8622']);
// FINISH::Added.by.KWShin.2026.10.28.
// BEGIN::Added.by.KWShin.2026.10.28.
// System Overview 의 Equalizer / OWLView(Scatter) 차트의 응답시간 구간별 기본 색(color)과 구간 값(rspn, ms).
// System Overview 화면(abap / java / custom spc)과 Preference > General > 차트 설정의 기본값이 같이 쓴다.
// 사용자가 차트 설정에서 저장하면 저장한 값이 우선한다. 마지막 구간(> )의 값은 바로 앞 구간의 값과 같다.
export const RSPN_SECTION_COLORS = Object.freeze([
  { color: '#87CC66', rspn: 500 }, // <= 500 ms
  { color: '#7BBAE7', rspn: 1500 }, // <= 1,500 ms
  { color: '#FFDD00', rspn: 4000 }, // <= 4,000 ms
  { color: '#FF7800', rspn: 6000 }, // <= 6,000 ms
  { color: '#FF0000', rspn: 6000 }, //  > 6,000 ms
]);
// FINISH::Added.by.KWShin.2026.10.28.

export const STORAGE_KEY_KEEP_LOGON = 'keep-logon';
export const STORAGE_KEY_KEEP_TOKEN = 'keep-token';
// FINISH::Added.by.KWShin.

// BEGIN::Added.by.KWShin.2025.06.24.
/**
 * 이거 함수를 export하는 게 이 파일의 성격과는 안 맞는데..
 * 데이터 성격은 상수이고... $t를 사용하려다 보니 이렇게 밖에 안되네..
 * 사용하는 쪽에서 함수로 호출해주어야 한다.
 */
export const TASK_TYPES = () => {
  const vue = window[VUE_INSTANCE_NAME];
  return [
    { id: '1', nm: vue.$t('owlview.tasktype.1') },
    { id: '2', nm: vue.$t('owlview.tasktype.2') },
    { id: '3', nm: vue.$t('owlview.tasktype.3') },
    { id: '4', nm: vue.$t('owlview.tasktype.4') },
    { id: '8', nm: vue.$t('owlview.tasktype.8') },
    { id: '254', nm: vue.$t('owlview.tasktype.254') },
    { id: '33', nm: vue.$t('owlview.tasktype.33') },
  ];
};

export const WP_TYPES = () => {
  const vue = window[VUE_INSTANCE_NAME];
  // eslint-disable-next-line prettier/prettier
  return [
    vue.$t('workprcs.type.1'),
    vue.$t('workprcs.type.2'),
    vue.$t('workprcs.type.3'),
    vue.$t('workprcs.type.4'),
    vue.$t('workprcs.type.5'),
    vue.$t('workprcs.type.6')
  ];
};
/**
 * WP Type 숫자(0~6) --> 라벨 문자열 매핑.
 * 기존 WP_TYPES는 건드리지 않고 신규 함수 생성하여 사용.
 */
export const WP_TYPE_QUEUE_BY_NUM = () => {
  const vue = window[VUE_INSTANCE_NAME];
  const map = Object.create(null);
  const count = WP_TYPES().length;
  for (let n = 0; n <= count; n++) {
    map[String(n)] = vue.$t(`workprcs.type.${n}`);
  }
  return map;
};
// FINISH::Added.by.KWShin.2025.06.24.

// BEGIN::Added.by.KWShin.2025.07.01.
export const LOWER_PGM_LIST = ['AutoABAP', 'Buf.Sync', 'Login_Pw'];
// FINISH::Added.by.KWShin.2025.07.01.

// BEGIN::Added.by.KWShin.2025.10.22.
/**
 * - model.enumtype.SapBatchStatus에서 X, Z은 제외.
 */
export const JOB_STATUS = () => {
  const vue = window[VUE_INSTANCE_NAME];
  return [
    // BEGIN::Modified.by.KWShin.2026.09.18.
    // Ready('Y')/Active('R')는 전이 상태라 어디에도 저장되지 않는다.
    // META_SAP_BATCH에는 'P'/'S'가, RAW_BATCH_LIST에는 'F'/'A'가 들어간다.
    // 고를 수는 있는데 아무것도 안 나오는 조건이어서 목록에서 뺀다.
    { value: 'P', title: vue.$t('dv.job.status.P') },
    { value: 'S', title: vue.$t('dv.job.status.S') },
    { value: 'F', title: vue.$t('dv.job.status.F') },
    { value: 'A', title: vue.$t('dv.job.status.A') },
    // FINISH::Modified.by.KWShin.2026.09.18.
  ];
};
// FINISH::Added.by.KWShin.2025.10.22.

// BEGIN::Added.by.KWShin.2026.01.14.
export const SOD_RISK_LEVEL = () => {
  const vue = window[VUE_INSTANCE_NAME];
  return [
    { value: 'L', title: vue.$t('sod.risk.level.L') },
    { value: 'M', title: vue.$t('sod.risk.level.M') },
    { value: 'H', title: vue.$t('sod.risk.level.H') },
    { value: 'C', title: vue.$t('sod.risk.level.C') },
  ];
};
export const SOD_RISK_TYPE = () => {
  const vue = window[VUE_INSTANCE_NAME];
  return [
    { value: 'A', title: vue.$t('sod.risk.type.A') },
    { value: 'P', title: vue.$t('sod.risk.type.P') },
  ];
};
// FINISH::Added.by.KWShin.2026.01.14.
